import { CopyButton, Button } from '@deephaven/components';
import "./ChartErrorOverlay.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ChartErrorOverlay(_ref) {
  var errorMessage = _ref.errorMessage,
    onDiscard = _ref.onDiscard,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel,
    dataTestId = _ref['data-testid'];
  var messageTestId = dataTestId != null ? "".concat(dataTestId, "-message") : undefined;
  return /*#__PURE__*/_jsx("div", {
    className: "chart-panel-overlay chart-error-overlay",
    children: /*#__PURE__*/_jsxs("div", {
      className: "chart-panel-overlay-content chart-error-overlay-content",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "info-message",
        "data-testid": messageTestId,
        children: [errorMessage, /*#__PURE__*/_jsx(CopyButton, {
          copy: errorMessage,
          UNSAFE_style: {
            margin: '0'
          },
          isQuiet: true
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [onCancel && /*#__PURE__*/_jsx(Button, {
          onClick: onCancel,
          kind: "secondary",
          children: "Cancel"
        }), onDiscard && /*#__PURE__*/_jsx(Button, {
          onClick: onDiscard,
          kind: "secondary",
          children: "Dismiss"
        }), onConfirm && /*#__PURE__*/_jsx(Button, {
          onClick: onConfirm,
          kind: "primary",
          children: "Continue"
        })]
      })]
    })
  });
}
export default ChartErrorOverlay;
//# sourceMappingURL=ChartErrorOverlay.js.map